import { styled } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"

export const InfoIcon = styled(InfoOutlined)({
  cursor: "default",
  marginLeft: 5,
  verticalAlign: "top"
})
